<div *ngIf="!isLoading" class="mt-2 d-flex" data-test-id="drop-down-content">
  <div ngbDropdown class="d-inline-block pb-3 width-200">
    <button ngbDropdownToggle data-test-id="sort-button" type="button" class="sort-btn">
      {{ 'SORT_BY_TITLE' | translate }} {{ nameTypeSorting | translate }}
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownMenu" autoClose="true" class="dropdown-menu-right width-200">
      <ng-container *ngFor="let option of sortOptions; index as index">
        <button
          type="button"
          [attr.data-test-id]="'sort-button-' + index"
          ngbDropdownItem
          (click)="toggleSortingOrderByType(option.sortCategory, option.sortTitle)"
        >
          {{ option.sortTitle | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
